import { render } from "./ModelElements.vue?vue&type=template&id=6fe80fb0"
import script from "./ModelElements.vue?vue&type=script&lang=js"
export * from "./ModelElements.vue?vue&type=script&lang=js"

import "./ModelElements.vue?vue&type=style&index=0&id=6fe80fb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__